import React, { useState, useEffect } from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { lightTheme, darkTheme, GlobalStyles } from './themes';

import Home from './pages/Home';
import Protected from './pages/Protected';

import SignIn from './pages/SignIn';



import CaissiersMarket from './pages/CaissiersMarket';
import CreationErase from './pages/CreationErase';

import Employes from './pages/Employes';
import Candidats from './pages/Candidats';
import Formations from './pages/Formations';
import Entretiens from './pages/Entretiens';
import Presences from './pages/Presences';
import Paiements from './pages/Paiements';
import Factures from './pages/Factures';
import Depenses from './pages/Depenses';
import Fournisseurs from './pages/Fournisseurs';
import Offres from './pages/Offres';
import ProfilEmployes from './pages/ProfilEmployes';
import ProfilClient from './pages/ProfilClient';
import ClientProfils from './pages/ClientProfils';
import CaisseBanque from './pages/CaisseBanque';
import Entreprise from './pages/Entreprise';
import Inscription from './pages/Inscription';
import Partenaires from './pages/Partenaires';
import EvaluationEmployes from './pages/EvaluationEmployes';
import CandidatProfils from './pages/CandidatProfils';
import Documents from './pages/Documents';
import HomePages from './pages/HomePages';
import Abouts from './pages/Abouts';
import ServicePages from './pages/ServicePages';
import FormationsPages from './pages/FormationsPages';
import OffresPAges from './pages/OffresPAges';
import PostulerPages from './pages/PostulerPages';
import ContactPages from './pages/ContactPages';
import FormationDetailPage from './pages/FormationDetailPage';
import PayRollEmployes from './pages/PayRollEmployes';
import Conges from './pages/Conges';
import CongeEmployes from './pages/CongeEmployes';
import InfoEntreprise from './pages/InfoEntreprise';
import FacturesPlacement from './pages/FacturesPlacement';
import Supervision from './pages/Supervision';
import ParamPaie from './pages/ParamPaie';
import CritaireEVA from './pages/CritaireEVA';
import { Presentation } from 'lucide-react';
import PresentationR from './pages/PresentationR';
import AdministrationR from './pages/AdministrationR';
import TutoCaisse from './pages/TutoCaisse';
import TutoRH from './pages/TutoRH';
import TutoFormation from './pages/TutoFormation';





function App() {
  const [theme, setTheme] = useState('light');

  // Charger le thème depuis le localStorage au démarrage
  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') || 'light';
    setTheme(savedTheme);
  }, []);

  // Fonction pour basculer le thème


  return (

    <ThemeProvider theme={theme === 'light' ? lightTheme : darkTheme}>
      <GlobalStyles />
      <HashRouter>
        {/* Ajouter un bouton pour basculer entre les thèmes */}
        
        
        <Routes>
          <Route path="/" element={<HomePages />} />
          <Route path="/about" element={<Abouts />} />
          <Route path="/services" element={<ServicePages />} />
          <Route path="/nos-formations" element={<FormationsPages />} />
          <Route path="/nos-offres" element={<OffresPAges />} />
          <Route path="/postuler/:titre/:id" element={<PostulerPages />} />
          <Route path="/infos-formations/:titre/:id" element={<FormationDetailPage />} />
          <Route path="/contact" element={<ContactPages />} /> 
          <Route path="/login" element={<SignIn />} />
          <Route path="/Home" element={<Protected Component={Home} />} />
          <Route path="/employes" element={<Protected Component={Employes} />} />
          <Route path="/conges" element={<Protected Component={Conges} />} />
          <Route path="/supervision" element={<Protected Component={Supervision} />} />
          <Route path="/evaluationEmploye" element={<Protected Component={EvaluationEmployes} />} />
          <Route path="/candidats" element={<Protected Component={Candidats} />} />
          <Route path="/formations" element={<Protected Component={Formations} />} />
          <Route path="/placement" element={<Protected Component={Entretiens} />} />
          <Route path="/presences" element={<Protected Component={Presences} />} />
          <Route path="/paiement" element={<Protected Component={Paiements} />} />
          <Route path="/factures" element={<Protected Component={Factures} />} />
          <Route path="/parametres-paie" element={<Protected Component={ParamPaie} />} />
          <Route path="/factures_placement" element={<Protected Component={FacturesPlacement} />} />
          <Route path="/depenses" element={<Protected Component={Depenses} />} />
          <Route path="/fournisseurs" element={<Protected Component={Fournisseurs} />} />
          <Route path="/offres" element={<Protected Component={Offres} />} />
          <Route path="/caisseBanque" element={<Protected Component={CaisseBanque} />} />
          <Route path="/partenaires" element={<Protected Component={Partenaires} />} />
          <Route path="/inscription" element={<Protected Component={Inscription} />} />
          <Route path="/profil-employe/:id" element={<Protected Component={ProfilEmployes} />} />
          <Route path="/pay-roll/:id" element={<Protected Component={PayRollEmployes} />} />
          <Route path="/Gestion-deconge/:id" element={<Protected Component={CongeEmployes} />} />
          <Route path="/clients" element={<Protected Component={ProfilClient} />} />
          <Route path="/client-Profil/:idcl" element={<Protected Component={ClientProfils} />} />
          <Route path="/infos_Entreprise/:id" element={<Protected Component={InfoEntreprise} />} />
          <Route path="/profil-candidat/:id" element={<Protected Component={CandidatProfils} />} />
          <Route path="/archivage" element={<Protected Component={Documents} />} />
         
          <Route path="/entreprise" element={<Protected Component={Entreprise} />} />

          <Route path="/admins" element={<Protected Component={CaissiersMarket} />} />
          <Route path="/manage-critaire" element={<Protected Component={CritaireEVA} />} />
          <Route path="/presentation" element={<Protected Component={PresentationR} />} />
          <Route path="/Administration" element={<Protected Component={AdministrationR} />} />
          <Route path="/TutoCaisse" element={<Protected Component={TutoCaisse} />} />
          <Route path="/TutoRH" element={<Protected Component={TutoRH} />} />
          <Route path="/TutoFormation" element={<Protected Component={TutoFormation} />} /> 

        
          <Route path="/Erase" element={<Protected Component={CreationErase} />} />
        </Routes>
      </HashRouter>
    </ThemeProvider>

  );
}

export default App;


